import ReactApexChart from "react-apexcharts";

const TenureWithTTEC = (data: any) => {

  if (!data || !data.data) {
    return <div>Unable to load chart data.</div>;
  }

  // Filter data and sort by tenure range from lowest to highest
  const filteredData = data.data.filter(
    (item: any) => item.count !== null && item.tenure_range !== null
  );

  // If no data after filtering, show message
  if (filteredData.length === 0) {
    return (
      <div id="chart2">
        <h3>How long have you been with TTEC?</h3>
        <div>No data available for this chart.</div>
      </div>
    );
  }

  // Custom sorting function for tenure ranges
  const sortTenureRanges = (a: any, b: any) => {
    const tenureOrder = [
      "<1 year",
      "less than 1 year",
      "1-2 years",
      "1-3 years",
      "2-3 years",
      "2-5 years",
      "3-5 years",
      "3-6 years",
      "5-10 years",
      "6-10 years",
      ">10 years",
      "more than 10 years",
      "10+ years",
    ];

    const aIndex = tenureOrder.findIndex(
      (range) =>
        a.tenure_range.toLowerCase().includes(range.toLowerCase()) ||
        range.toLowerCase().includes(a.tenure_range.toLowerCase())
    );
    const bIndex = tenureOrder.findIndex(
      (range) =>
        b.tenure_range.toLowerCase().includes(range.toLowerCase()) ||
        range.toLowerCase().includes(b.tenure_range.toLowerCase())
    );

    // If both found in order array, sort by index
    if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
    // If only one found, put the found one first
    if (aIndex !== -1) return -1;
    if (bIndex !== -1) return 1;
    // If neither found, sort alphabetically as fallback
    return a.tenure_range.localeCompare(b.tenure_range);
  };

  const sortedData = [...filteredData].sort(sortTenureRanges);
  const series = sortedData.map((item: any) => item.count);
  const labels = sortedData.map((item: any) => item.tenure_range);

  // Default colors for the chart segments
  const defaultColors = [
    "#0074ccff",
    "#c1e96bff",
    "#e0e08cff",
    "#ffcc00ff",
    "#46c4f6ff",
    "#ff7f0eff",
    "#2ca02cff",
    "#d62728ff",
    "#9467bdff",
    "#8c564bff",
    "#e377c2ff",
    "#7f7f7fff",
    "#bcbd22ff",
    "#17becfff",
    "#1f77b4ff",
    "#ff7f0eff",
    "#d62728ff",
    "#9467bdff",
    "#8c564bff",
    "#e377c2ff",
    "#7f7f7fff",
    "#bcbd22ff",
    "#17becfff",
    "#1f77b4ff",
  ];

  const options = {
    chart: {
      type: "donut" as "donut",
      events: {
        dataPointSelection: (event: any, chartContext: any, config: any) => {
          try {
            if (
              config &&
              config.w &&
              config.w.config &&
              config.w.config.labels &&
              typeof config.dataPointIndex === "number" &&
              config.dataPointIndex >= 0 &&
              config.dataPointIndex < config.w.config.labels.length
            ) {
            } else {
            }
          } catch (error) {
          }
        },
      },
    },
    labels: labels,
    colors: defaultColors.slice(0, series.length), // Use only as many colors as needed
    legend: {
      position: "bottom" as "bottom",
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 250,
          },
          legend: {
            position: "bottom" as "bottom",
          },
        },
      },
    ],
  };

  return (
    <div id="chart-tenure-ttec">
      <h3>How long have you been with TTEC?</h3>
      <ReactApexChart
        options={options}
        series={series}
        type="donut"
        width={450}
      />
    </div>
  );
};

export default TenureWithTTEC;
